import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Compliance } from '@app/services/compliance.service';

import { interval, of, Subscription } from 'rxjs'; 
import { catchError, finalize, switchMap, take, takeWhile, tap } from 'rxjs/operators';
@Component({
  standalone: false,
  selector: 'app-compliance-layout',
  templateUrl: './compliance-layout.component.html',
  styleUrls: ['./compliance-layout.component.css'],
})
export class ComplianceLayoutComponent implements OnInit {
  pageTitle = '';
  cashCageForm: FormGroup;
  scanning = false;
  selfie = false;
  private pollingSubscription: Subscription | null = null;
  isLoading = false;
  imgFront: string;
  imgBack: string;
  isScanningSide: string;
  req_id_back: string;
  req_id_front: string;
  operation_id: string;
  isScaningLoad = false;
  cashCageDetails: any
  condents:any
  selectionApi:any

  leftFormFields = [
    
    { label: 'Address Line 1', controlName: 'addressline1', type: 'text', placeholder: 'Address Line 1' },
    { label: 'Address Line 2', controlName: 'addressline2', type: 'text', placeholder: 'Address Line 2' },
    { label: 'City', controlName: 'city', type: 'text', placeholder: 'City' },
    { label: 'State', controlName: 'state', type: 'text', placeholder: 'State' },
    { label: 'Zip', controlName: 'zip', type: 'text', placeholder: 'Zip' },
    { label: 'Country', controlName: 'country', type: 'text', placeholder: 'Country' },
  ];

  rightFormFields = [
    { label: 'First Name', controlName: 'firstName', type: 'text', placeholder: 'First Name' },
    { label: 'Last Name', controlName: 'lastName', type: 'text', placeholder: 'Last Name' },
    {
      label: 'Date of Birth',
      controlName: 'dob',
      type: 'text',
      placeholder: 'YYYY-MM-DD',
      maxLength: 10,
      pattern: '\\d{2}/\\d{2}/\\d{4}',
    },
    {
      label: 'SSN',
      controlName: 'ssn',
      type: 'text',
      placeholder: 'SSN',
      maxLength: 11,
      pattern: '\\d{3}-\\d{2}-\\d{4}',
    },
    {
      label: 'Phone Number',
      controlName: 'phone',
      type: 'text',
      placeholder: 'Phone Number',
      maxLength: 12,
      pattern: '\\d{3}-\\d{3}-\\d{4}',
    },
    { label: 'Email', controlName: 'email', type: 'email', placeholder: 'Email' },
    
  ];

  constructor(private scan: Compliance, private route: ActivatedRoute, private fb: FormBuilder) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const page = params.get('page');
      this.pageTitle = page ? this.capitalizeFirstLetter(page) : 'Page Not Found';
    });
    this.cashCageForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      dob: ['', [Validators.required, this.dobValidator]],
      phone: ['', [Validators.required, this.phoneValidator]],
      email: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],
      ssn: ['', [Validators.required, this.ssnValidator]],
      addressline1: ['', Validators.required],
      addressline2: ['', Validators.required],
      city: ['', Validators.required],
      zip: ['', Validators.required],
      state: ['', Validators.required],


    });
  }

  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  dobValidator(control: FormControl) {
    const dobRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    return control.value && !dobRegex.test(control.value) ? { invalidDob: true } : null;
  }

  phoneValidator(control: FormControl) {
    const cleaned = control.value.replace(/\D/g, '');
    return cleaned.length !== 10 ? { invalidPhone: true } : null;
  }

  ssnValidator(control: FormControl) {
    const cleaned = control.value.replace(/\D/g, '');
    return cleaned.length !== 9 ? { invalidSsn: true } : null;
  }

  clearForm() {
    this.cashCageForm.reset();
  }

  jackpotAction() {
    console.log('Jackpot Action triggered.');
  }

  Documents() {
    this.scanning = true;
  }

  scanningID(scanningSide: string) {
    this.isScaningLoad = true;
    this.isScanningSide = scanningSide;
    this.scan.postScanning(scanningSide).subscribe(
      (response) => {
        if (response.request_id) {
          this.getImages(scanningSide, response.request_id);
        }
      },
      (error) => {
        console.log(error);
        this.isScaningLoad = !true;
      },
    );
  }

  closeScanning() {
    this.scanning = false;
    this.stopPolling();
    this.req_id_front = ""
    this.req_id_back = ""
    this.imgBack = ""
    this.imgFront = ""
  }

  // Polling methods
  getImages(imageSide: string, requestId: any) {
    if (this.pollingSubscription) {
      this.stopPolling();
    }
    let pollingCount = 0;
    this.pollingSubscription = interval(5000)
      .pipe(
        take(6),
        switchMap(() => {
          pollingCount++;
          return this.scan.getScanning(imageSide, requestId).pipe(
            catchError((error) => {
              console.error('Polling Error:', error);
              return of(null);
            }),
          );
        }),
        takeWhile((response) => !this.isScanComplete(response)),
        tap((response) => {
          if (response.data) {
            if (imageSide === 'scan_front') {
              const base64 = `data:image/png;base64,${response.data}`;
              this.imgFront = base64;
              this.req_id_front = requestId;
            } else if (imageSide === 'scan_back') {
              const base64 = `data:image/png;base64,${response.data}`;
              this.imgBack = base64;
              this.req_id_back = requestId;
            }
            this.stopPolling();
          } else if (pollingCount === 6) {
            console.error('Error: Maximum polling attempts reached.');
            this.stopPolling();
          }
        }),
      )
      .subscribe(
        (response) => console.log('Polling Response:', response),
        (error) => console.error('Final Error:', error),
      );
  }

  updatesImgs() {
    this.isLoading = true;
    this.scan.uploadImgs(this.req_id_front, this.req_id_back).subscribe(
      (response) => {
        this.isLoading = !true;
        this.closeScanning()
        this.operation_id = response.operation_id;
        this.callOperationId(response.operation_id);
      },
      (error) => {
        this.isLoading = !true;
        console.error('Upload Error:', error);
      },
    );
  }

  private isScanComplete(response: any): boolean {
    return response && response.status === 'COMPLETED';
  }

  private stopPolling() {
    this.isScaningLoad = !true;
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
  }

  private callOperationId(operation_id:string) {
    this.scan.getProofResults(operation_id).subscribe(
      (response) => {
        const cashcageCustomerDetails = response.response_data.sections.filter((i) => i.title === "Document Details")[0].contents[0]
        if (cashcageCustomerDetails) {
          const addressParts = cashcageCustomerDetails.Address.split('^');

          let formattedDOB = '';
          if (cashcageCustomerDetails.DateOfBirth) {
            const dobParts = cashcageCustomerDetails.DateOfBirth.split('/');
            if (dobParts.length === 3) {
              formattedDOB = `${dobParts[2]}-${dobParts[0].padStart(2, '0')}-${dobParts[1].padStart(2, '0')}`;
            }
          }

          this.cashCageForm.patchValue({
            firstName: cashcageCustomerDetails.NameOfHolder.split(' ')[1] || '',
            lastName: cashcageCustomerDetails.NameOfHolder.split(' ')[0] || '',
            dob: formattedDOB || '',
            addressline1: addressParts[0] || '',
            addressline2: addressParts[1] || '',
            city: cashcageCustomerDetails.AddressCity || '',
            state: cashcageCustomerDetails.AddressJurisdictionCode || '',
            zip:'',
            country: cashcageCustomerDetails.IssuingStateName || '',
          });
        }
        this.Screen()
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'NO MATCH':
        return 'no-match';
      case 'MATCH':
        return 'match';
      case 'SKIPPED':
        return 'skipped';
      case 'ERROR':
        return 'error';
      default:
        return '';
    }
  }


  Screen(){
    this.isLoading = true
    const cashCageData = {
      firstname: this.cashCageForm.value.firstName,
      lastname: this.cashCageForm.value.lastName,
      date_of_birth: this.cashCageForm.value.dob,
      address_line_1: this.cashCageForm.value.addressline1,
      address_line_2: this.cashCageForm.value.addressline2,
      state: this.cashCageForm.value.state,
      city: this.cashCageForm.value.city,
      zip: this.cashCageForm.value.zip,
      email: this.cashCageForm.value.email,
    }
    this.scan.cashCage(cashCageData)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response) => {
        const res = response.results;
        this.cashCageDetails = cashCageData;
        const title = ["Gaming Exclusion List", "ITRAK Exclusion List", "Sanctions"];
        const data = title.map(apiName => {
          const matchedResult = res.find((i) => i.rule === apiName); 
          return {
            APIName: apiName,
            Status: matchedResult.api_result.status
              ? matchedResult.api_result.status.toUpperCase()
              : 'ERROR',
            sections: matchedResult.api_result.matches || []
          };
        });
        this.condents = data;
        this.isLoading = false;
      });
}

  openApiData(sections:any){
    this.selectionApi = sections
    console.log(sections)
  }
}
